'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var useMuiScrollTrigger = require('@material-ui/core/useScrollTrigger');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var useMuiScrollTrigger__default = /*#__PURE__*/_interopDefaultLegacy(useMuiScrollTrigger);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ["children"];
var ScrollTriggerContext = /*#__PURE__*/React__default["default"].createContext({
  trigger: false,
  direction: 0
});
var ScrollTriggerContextProvider = function ScrollTriggerContextProvider(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var trigger = useMuiScrollTrigger__default["default"](rest);
  return /*#__PURE__*/React__default["default"].createElement(ScrollTriggerContext.Provider, {
    value: {
      trigger: trigger
    }
  }, children);
};
ScrollTriggerContextProvider.propTypes = {
  children: PropTypes__default["default"].node.isRequired
};
var warnIfNotInContext = function warnIfNotInContext(ctx) {
  if (!ctx) {
    console.error('useScrollTrigger must be used within a ScrollTriggerContextProvider');
    return true;
  }
  return false;
};
var useScrollingDownTrigger = function useScrollingDownTrigger() {
  var ctx = React.useContext(ScrollTriggerContext);
  if (warnIfNotInContext(ctx)) {
    return false;
  }
  return ctx.trigger;
};
var useScrollingUpTrigger = function useScrollingUpTrigger() {
  var ctx = React.useContext(ScrollTriggerContext);
  if (warnIfNotInContext(ctx)) {
    return false;
  }
  return !ctx.trigger;
};

exports.ScrollTriggerContext = ScrollTriggerContext;
exports.ScrollTriggerContextProvider = ScrollTriggerContextProvider;
exports.useScrollingDownTrigger = useScrollingDownTrigger;
exports.useScrollingUpTrigger = useScrollingUpTrigger;
//# sourceMappingURL=index.module.js.map
